import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WkTreeViewComponent } from './custom-tree-view.component';
import { MatTreeModule } from '@angular/material/tree';
import { MaterialModule } from '../../../material.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatTreeModule,
    TranslateModule.forChild(),
  ],
  declarations: [WkTreeViewComponent],
  exports: [WkTreeViewComponent],
})
export class CustomTreeViewModule {}
